import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || '';
const API_URL = `${BASE_URL}/api/esp32`;

// Connect a new device with the logged-in user
const connect = async (data, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }
    }
    
    const response = await axios.put(`${API_URL}/connect`, data, config);
    return response;
};

// Get logged-in user's devices
const getUserDevices = async (data, token) => {
    const response = axios({ method: 'get', url: API_URL + '/user-devices', headers: { 'Authorization': 'Bearer ' + token } });
    return response;
};

// Get sensor data entries from the database
const getSensorData = async (data, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }
    }
    const response = await axios.post(`${API_URL}/get-sensor-data`, data, config);
    return response;
};

const sensorService = {
    connect,
    getUserDevices,
    getSensorData
};

export default sensorService;